<template>
    <div class="roothome">

        <div class="wrapper">
            <!--<side-menu/>-->

            <!-- Sidebar Holder -->
            <nav id="sidebar">
                <div class="sidebar-header" style="font-size: 1.1em; display: flex; align-items: center; height: 40vh;">

                    <div style="width: 100%; text-align: center;">
                        <img src="/static/imgs/advicep_horizontal_w.png" alt="menu" style="width: 70%; max-height: 10vh; margin-top: 5vh; margin-bottom: 2.5vh; object-fit: contain">
                    </div>

                    <!--<div style="margin-bottom: 2.5vh">-->
                        <!--<span class="tx_idioma" v-if="user.idioma==0" style="font-family: 'Humanst521BT';">Português</span>-->
                        <!--<span class="tx_idioma" v-if="user.idioma!=0" @click="changeIdioma(0)">Português</span>-->
                        <!--<span class="tx_idioma">&#149;</span>-->
                        <!--<span class="tx_idioma" v-if="user.idioma==1" style="font-family: 'Humanst521BT';">English</span>-->
                        <!--<span class="tx_idioma" v-if="user.idioma!=1" @click="changeIdioma(1)">English</span>-->
                        <!--<span class="tx_idioma">&#149;</span>-->
                        <!--<span class="tx_idioma" v-if="user.idioma==2" style="font-family: 'Humanst521BT';">Español</span>-->
                        <!--<span class="tx_idioma" v-if="user.idioma!=2" @click="changeIdioma(2)">Español</span>-->
                    <!--</div>-->

                    <div v-if="user.sucess" style="width: 100%; text-align: center; display: flex; flex-direction: column; align-items: center;">
                        <span style="font-size: 2.5vh;">{{ getInterText(inter_ind.ola) }} {{ getFirstAndLastWords(user.nome) }}</span>

                        <div class="div_botao_t" @click="logout()" onMouseOver="this.style.cursor='pointer'">
                            <span class="tx_continuar"> {{ getInterText(inter_ind.sair) }} </span>
                        </div>
                    </div>
                    <div v-else style="width: 100%; text-align: center; display: flex; flex-direction: column; align-items: center;">
                        <router-link to="registerUser" style="width: 100%; text-align: center; display: flex; flex-direction: column; align-items: center;">
                            <div class="div_botao_t_w">
                                <span class="tx_continuar"> {{ getInterText(inter_ind.cadastre) }} </span>
                            </div>
                        </router-link>

                        <div class="div_botao_t" @click="setShowLogin(true)">
                            <span class="tx_continuar"> {{ getInterText(inter_ind.entrar) }} </span>
                        </div>
                    </div>

                    <!-- Filtro cidades - menu lateral -->
                    <div class="custom-select-filtro">
                        <select class=".selectCity" id="sel_cats" @change="changeCity($event)" v-model="cityIndex" >
                            <option value="0" v-if="city_full.length > 0"> {{ city_full[0].nome }} </option>
                            <option v-for="(item, index) in city_full" :value="index" v-if="index > 0"> {{ item.nome }} ({{ item.quant }}) </option>
                        </select>
                        <img src="/static/imgs/ic_down.png" style="width: 5%; margin-right: 3%; object-fit: contain;">
                    </div>


                </div>
                <div style="display: flex; flex-direction: column; height: 57vh;">
                <ul class="list-unstyled components noScrollMenu" style="margin-top: 0; display: flex; flex-direction: column; overflow-y: scroll; font-size: 1.2vw; height: max-content; flex-grow: 90; flex-shrink: 0;">
                    <li class="active">
                        <a href="#pageSubmenu" data-toggle="collapse" aria-expanded="false" aria-controls="pageSubmenu" style="font-family: 'Humanst521BT';">{{ getInterText(inter_ind.categorias) }}</a>
                        <ul class="collapse list-unstyled" id="pageSubmenu" >
                            <li v-for="(item, index) in cats_full" v-if="index > 0" @click="atualizaEstabs(item.id, true)">
                                <div class="lineMenu">
                                    <img v-if="item.imgPath2!=null" :src="baseUrlImg + 'CATEGORIA/' + item.imgPath2" class="im_cat_min">
                                    <span style="font-size: 2.2vh;">{{ getInterCatName(item) }}</span>
                                </div>
                            </li>
                        </ul>
                    </li>
                    <li>
                        <a href="/Visao" style="font-family: 'Humanst521BT';">{{ getInterText(inter_ind.quem_somos) }}</a>
                    </li>

                    <li class="active">
                        <a style="font-family: 'Humanst521BT';" href="#pageSubmenu3" data-toggle="collapse" aria-expanded="false" aria-controls="pageSubmenu3">{{ getInterText(inter_ind.nossas_redes) }}</a>
                        <ul class="collapse list-unstyled" id="pageSubmenu3" >
                            <li>
                                <a href="https://www.facebook.com/adviceparaiba" target="_blank">
                                    <img src="/static/imgs/ic_facebookmenu.png" class="im_cat_min_2">
                                    <span>Facebook</span>
                                </a>
                                <a href="https://www.youtube.com/channel/UCbWLHHK-IIHT6BZRWU0n5eg" target="_blank">
                                    <img src="/static/imgs/ic_youtubemenu.png" class="im_cat_min_2">
                                    <span>YouTube</span>
                                </a>
                                <a href="https://www.instagram.com/adviceparaiba/" target="_blank">
                                    <img src="/static/imgs/ic_instagrammenu.png" class="im_cat_min_2">
                                    <span>Instagram</span>
                                </a>
                                <a href="https://twitter.com/AdviceParaiba" target="_blank">
                                    <img src="/static/imgs/ic_twittermenu.png" class="im_cat_min_2">
                                    <span>Twitter</span>
                                </a>
                            </li>
                        </ul>
                    </li>
                    <li @click='goToPagina("tabua")'>
                        <a style="font-family: 'Humanst521BT'; pointer-events: none;"> {{ getInterText(inter_ind.tabua_mares) }} </a>
                    </li>
                    <!--<li @click="changeShow10Mais()" style="cursor: pointer;">-->
                        <!--<a style="font-family: 'Humanst521BT';" >{{ getInterText(inter_ind.os) }} 10+</a>-->
                    <!--</li>-->
                    <li>
                        <a href="/Contato" style="font-family: 'Humanst521BT';">{{ getInterText(inter_ind.contato) }}</a>
                    </li>
                    <li>
                        <a href="/ExpedicaoAdvice" style="font-family: 'Humanst521BT';">{{ getInterText(inter_ind.expedicao) }}</a>
                    </li>
                    <li class="active">
                        <a style="font-family: 'Humanst521BT';" href="#pageSubmenu2" data-toggle="collapse"x aria-expanded="false" aria-controls="pageSubmenu2">{{ getInterText(inter_ind.telefones_uteis) }}</a>
                        <ul class="collapse list-unstyled" id="pageSubmenu2">
                            <li v-for="item in telefoneUteis">
                                <a :href="'tel:' + trimAll(item.tel)" style="margin-left: 5px">{{ getInterText(item.nome) }}: {{ item.tel }}</a>
                            </li>
                        </ul>
                    </li>
                </ul>

                <!-- PARCEIROS -->
                <!--<div class="div_pat_m">-->
                    <!--<hr class="hr_pat"/>-->
                    <!--<div style="display: flex;">-->
                        <!--<a v-for="item in barra_pat" :href="item.url" target="_blank"><img :src="item.imgPathW" class="im_pat_m"/></a>-->
                    <!--</div>-->
                <!--</div>-->
                </div>
            </nav>

            <div class="section_desk" id="sidebarCollapse" @click="changeSideBar()">
                <a class="navicon-button x" id="icmenu" >
                    <div v-if="!modoMosaico" class="navicon">
                    </div>
                </a>
            </div>


            <div style="display: flex; justify-content: center;">
                <!-- ################    Top Menu Bar    ################# -->
                <div align="center" class="head0" style="text-align: center">
                    <div class="head1" style="justify-content: flex-start;">
                        <img v-if="modoMosaico" src="/static/imgs/ic_back_b.png" alt="menu" class="im_menu2" style="padding-left: 10%;" @click="atualizaEstabsToggle(cat.id)" onMouseOver="this.style.cursor='pointer'">
                        <!--<div class="bar_cidades">-->
                            <!--<span v-if="city_full[cityIndex] != null" style="font-size: 2vh; color: black"> {{ city_full[cityIndex].nome }} </span>-->
                            <!--<select @change="changeCity($event)" v-model="cityIndex" style="border:0px; outline:0px; border: none; scroll-behavior: smooth; background-color: white; -webkit-appearance:none; font-size: 2vh; position: absolute; opacity: 0; width: 26vh;">-->
                                <!--<option value="0" v-if="city_full.length > 0"> {{ city_full[0].nome }} </option>-->
                                <!--<option v-for="(item, index) in city_full" :value="index" v-if="index > 0"> {{ item.nome }} ({{ item.quant }}) </option>-->
                            <!--</select>-->
                        <!--</div>-->
                        <img src="/static/imgs/advicep_horizontal.png" @click="clearCategorias()" alt="logo advice" class="im40_2" style="cursor: pointer;">
                    </div>

                    <div  class="head3" style="width: 70%; margin-left: 3%;">
                        <!--<div style="display: flex; height: 35%; width: 100%; align-items: center; justify-content: center;">-->
                            <!--<div class="bar_idiomas">-->
                                <!--<img v-if="user.idioma==0" src="/static/imgs/ic_b_pt.jpg" alt="barra idiomas" style="height: 70%;">-->
                                <!--<img v-if="user.idioma==1" src="/static/imgs/ic_b_en.jpg" alt="barra idiomas" style="height: 70%;">-->
                                <!--<img v-if="user.idioma==2" src="/static/imgs/ic_b_es.jpg" alt="barra idiomas" style="height: 70%;">-->
                                <!--<span style="font-size: 2vh; color: black; margin-right: 7%;"> {{ getIdioma(user.idioma) }} </span>-->
                                <!--<select id="changeIdiomaSelect" @change="changeIdiomaSelector($event)" v-model="user.idioma" style="border:0px; outline:0px; border: none; scroll-behavior: smooth; background-color: white; -webkit-appearance:none; font-size: 2vh; position: absolute; opacity: 0; width: 100%;">-->
                                    <!--<option value="0"> {{ getIdioma(0) }}&nbsp;&nbsp;&nbsp;&nbsp;</option>-->
                                    <!--<option value="1"> {{ getIdioma(1) }}&nbsp;&nbsp;&nbsp;&nbsp;</option>-->
                                    <!--<option value="2"> {{ getIdioma(2) }}&nbsp;&nbsp;&nbsp;&nbsp;</option>-->
                                <!--</select>-->
                            <!--</div>-->
                        <!--</div>-->

                        <!--<div style="">-->
                            <!--<span class="tx_idioma" v-if="user.idioma==0" style="font-family: 'Humanst521BT';">Português</span>-->
                            <!--<span class="tx_idioma" v-if="user.idioma!=0" @click="changeIdioma(0)">Português</span>-->
                            <!--<span class="tx_idioma">&#149;</span>-->
                            <!--<span class="tx_idioma" v-if="user.idioma==1" style="font-family: 'Humanst521BT';">English</span>-->
                            <!--<span class="tx_idioma" v-if="user.idioma!=1" @click="changeIdioma(1)">English</span>-->
                            <!--<span class="tx_idioma">&#149;</span>-->
                            <!--<span class="tx_idioma" v-if="user.idioma==2" style="font-family: 'Humanst521BT';">Español</span>-->
                            <!--<span class="tx_idioma" v-if="user.idioma!=2" @click="changeIdioma(2)">Español</span>-->
                        <!--</div>-->
                        <!--<span class="tx_title_guia">Seu Guia Turístico na Paraíba</span>-->
                        <span class="tx_title_guia" style="margin-left: 60px;">{{getInterText(inter_ind.seu_guia_turistico)}}</span>

                        <!--<div style="display: flex; height: 40%; margin-left: 10%; margin-right: 10%;">-->
                            <!--<a target="_blank" href="https://www.youtube.com/channel/UCbWLHHK-IIHT6BZRWU0n5eg"><img src="/static/imgs/ic_youtube2.png" alt="youtube" class="im_social"></a>-->
                            <!--<a target="_blank" href="https://www.facebook.com/adviceparaiba/"><img src="/static/imgs/ic_face2.png" alt="facebook" class="im_social"></a>-->
                            <!--<a target="_blank" href="https://www.instagram.com/adviceparaiba/"><img src="/static/imgs/ic_instagram2.png" alt="instagram" class="im_social"></a>-->
                            <!--<a target="_blank" href="https://twitter.com/AdviceParaiba"><img src="/static/imgs/ic_twitter2.png" alt="twitter" class="im_social"></a>-->
                        <!--</div>-->
                    </div>
                    <div  class="head4" style="margin-right: -40%;">
                        <div v-if="!user.sucess" style="display: flex; flex-direction: row; align-items: center; height: 100%;">
                            <!--<router-link to="registerUser">-->
                            <div style="display: flex; height: 100%; min-height: 100%; align-items: flex-end;">
                                <div class="im_id_container">
                                    <img class="im_id" v-if="user.idioma==0" src="/static/imgs/ic_pt2.png"/>
                                    <img class="im_id" v-if="user.idioma!=0" src="/static/imgs/ic_pt1.png" @click="changeIdioma(0)"/>
                                    <img class="im_id" v-if="user.idioma==1" src="/static/imgs/ic_en2.png"/>
                                    <img class="im_id" v-if="user.idioma!=1" src="/static/imgs/ic_en1.png" @click="changeIdioma(1)"/>
                                    <img class="im_id" v-if="user.idioma==2" src="/static/imgs/ic_es2.png"/>
                                    <img class="im_id" v-if="user.idioma!=2" src="/static/imgs/ic_es1.png" @click="changeIdioma(2)"/>
                                </div>
                                <a href="/registerUser" >
                                    <span class="tx_login2" >{{ getInterText(inter_ind.cadastre) }} </span>
                                </a>
                            </div>
                            <!--</router-link>-->
                            <div style="display: flex; flex-direction: column; align-items: center;">
                                <img @click="setShowLogin(true)" onMouseOver="this.style.cursor='pointer'" src="/static/imgs/ic_profile2.png" alt="profile" class="im_profile" style="height: 25%; margin-right: 0; margin-left: 0; margin-bottom: -15%;">

                                <span class="tx_login" style="margin-bottom: 0; margin-top: 7%; color: var(--gray-menu)" @click="setShowLogin(true)" onMouseOver="this.style.cursor='pointer'">{{ getInterText(inter_ind.entrar) }}</span>
                            </div>
                        </div>
                        <div v-else @click="showPopEscritorio()" style="cursor: pointer;">
                            <div class="im_id_container" style=" margin-right: 130px">                                <img class="im_id" v-if="user.idioma==0" src="/static/imgs/ic_pt2.png"/>
                                <img class="im_id" v-if="user.idioma!=0" src="/static/imgs/ic_pt1.png" @click="changeIdioma(0)"/>
                                <img class="im_id" v-if="user.idioma==1" src="/static/imgs/ic_en2.png"/>
                                <img class="im_id" v-if="user.idioma!=1" src="/static/imgs/ic_en1.png" @click="changeIdioma(1)"/>
                                <img class="im_id" v-if="user.idioma==2" src="/static/imgs/ic_es2.png"/>
                                <img class="im_id" v-if="user.idioma!=2" src="/static/imgs/ic_es1.png" @click="changeIdioma(2)"/>
                            </div>
                            <div v-if='user.foto === ""' class="im_profile" style="text-align: center; padding-top: 1.2vh; background-color: var(--bg-blue)">
                                <span class="tx_initials" >{{ getInitials(user) }}</span>
                            </div>
                            <img id="botao_profile2" v-else-if='hasHttp(user.foto)'  :src='user.foto' alt="profile" class="im_profile" >
                            <img id="botao_profile3" v-else :src='baseUrlImg + "PROFILE/" + user.foto'     alt="profile" class="im_profile">
                            <br>
                            <span class="tx_login5" >{{ getFirstAndLastWords(user.nome) }}</span>
                            <div style="width: 100%; display: flex; justify-content: center;">
                                <div class="triangle"></div>
                            </div>
                        </div>
                        <div v-if="showPopupEscritorio" class="di_popescritorio" id="popup_escritorio">
                            <div class="arrow_top"></div>
                            <!--<span class="tx_login" >{{ user.nome }}</span>-->
                            <div style="display: flex; flex-direction: column; height: 15vh; justify-content: space-evenly;">
                                <router-link :to="{ params: { stabs: estabs_full, categs: cats_full, idCat: idCat}, name: 'MinhaPagina'}">
                                    <span class="tx_login" onMouseOver="this.style.cursor='pointer'">{{ getInterText(inter_ind.minha_conta) }}</span>
                                </router-link>
                                <span class="tx_login" onMouseOver="this.style.cursor='pointer'" @click="goToPagina('EditUser')">{{ getInterText(inter_ind.configuracoes) }}</span>
                                <span class="tx_login" onMouseOver="this.style.cursor='pointer'" @click="logout()">{{ getInterText(inter_ind.sair) }}</span>
                            </div>
                        </div>
                    </div>

                </div>

                <div class="title4">
                    <div class="additional-image-container" style="width: 100%; display: flex; justify-content: center; margin-bottom: 20px; margin-top: 100px;">
                        <a href="https://adviceparaiba.com/s/estaleirorestaurantebessa" target="_blank">
                            <img src="/static/imgs/happyhour.jpeg" alt="Happy Hour" style="width: 100%; max-width: 1200px; height: auto; object-fit: cover;">
                        </a>
                    </div>

                <!-- ################    panorama e busca    ################# -->
                <div v-if="!modoMosaico || searching" class="title2" style="display: flex; flex-direction: column; align-items: center; position: relative; margin-top:-10px">
                    <div class="title2_2">
                        <!--<img src="/static/imgs/panoramica02.jpg" alt="panoramica" class="im100_search">-->
                        <img :src="pano[panoInd].imgPath" alt="panoramica" class="im100_search" style="width: 100%; height: auto; max-height: 400px; object-fit: cover;">
                    </div>

                    <div class="dv_search">
                        <input type="text" class="search2"  v-on:keyup.enter="closeKey()" onsubmit="closeKey()"  v-on:keyup="getEstabsSearch()" v-model="search_text" :placeholder="getInterText(inter_ind.pesquisar) + '...'">
                        <img src="/static/imgs/ic_lupa3.png" class="im_search" style="margin-left: 5%"/>
                    </div>
                    <!--<input type="text" class="search"  v-on:keyup.enter="closeKey()" onsubmit="closeKey()"  v-on:keyup="getEstabsSearch()" v-model="search_text" :placeholder="getInterText(inter_ind.pesquisar) + '...'">-->
                </div>
                <div v-else style="height: var(--top-bar-heigth_desk);"/>

                <div style="width: 100%; height: 4vh;"/>

                <div v-if="show10Mais" style="text-align: center; font-size: 3vh; margin-bottom: 3vh">
                    <span style="flex-grow: 1;" > {{ getInterText(inter_ind.os) }} 10+ </span>
                    <!--<img src="/static/imgs/ic_selo10.png" style="object-fit: scale-down; width: 4vh; height: 100%; margin-right: 1%;"/>-->
                </div>

                <!-- Filtro Cidades lado direito -->
                <div v-if="city_full[cityIndex] != null" style="display: flex; justify-content: flex-end; height: 3.1vh; width: auto; color: white; z-index: 10;">
                    <!-- Filtro Cidades -->
                    <div style="background-color: white; z-index: 10; width: 20%; display: flex; white-space: nowrap; justify-content: flex-end; height: 100%; pointer-events: none;">
                        <div class="custom-select-filtro" style="display: flex; border-radius: 5px; margin-top: 0; margin-right: 0; height: 3.1vh; width: auto; padding-right: 1vh; padding-left: 6%; align-items: center;  z-index: 10;">
                            <span style="font-size: 2vh;">{{city_full[cityIndex].nome}}</span>
                            <img class="arrow-container_img" src="/static/imgs/ic_down.png" style="object-fit: contain;">
                            <!--<div class="arrow-container">-->
                                <!--<div class="arrow arrow-down_b"/>-->
                            <!--</div>-->
                        </div>
                    </div>
                </div>
                <div style="display: flex; justify-content: flex-end; height: 3.1vh; margin-top: -3.1vh; margin-bottom: -2vh; z-index: 0;">
                    <!-- Filtro Cidades -->
                    <div class="custom-select-filtro" style="width: 20%; border-radius: 5px; margin-top: 0; margin-right: 0; height: 3.1vh; background-color: unset; color: transparent; z-index: 0;">
                        <select id="sel_cats2" @change="changeCity($event)" v-model="cityIndex" style="height: 2.9vh;">
                            <option value="0" v-if="city_full.length > 0"> {{ city_full[0].nome }} </option>
                            <option v-for="(item, index) in city_full" :value="index" v-if="index > 0"> {{ item.nome }} ({{ item.quant }}) </option>
                        </select>
                    </div>
                </div>

                <!-- ################    Estabelecimentos por Search    ################# -->
                <!-- ################    Estabelecimentos por Categoria    ################# -->
                <div v-for="(cat, index) in cats" v-if="estabsMat_ok && cats.length!=0 && ((!show10Mais && index > 0) || (index > 0 || modoMosaico) )" style="margin-bottom: 3vh;">
                    <div v-if="index === 4" class="additional-image-container" style="width: 100%; display: flex; justify-content: center; margin-bottom: 20px; margin-top: 20px;">
                        <a href="https://linktr.ee/estaleirorestaurante" target="_blank">
                            <img src="/static/imgs/culinaria.jpeg" alt="culinaria" class="culinaria-image" style="width: 100%; max-width: 1200px; height: auto; object-fit: cover;">
                        </a>
                    </div>
                    <!--<br>-->
                    <div class="title3_v2" v-if="estabsMat.get(cat.id).length!=0 || cat.id == -1">
                        <img onerror="tryReloadImages(this)" v-if="cat.id>=0" :src="baseUrlImg + 'CATEGORIA/' + cat.imgPath2" alt="categorias" class="im_categoria2" @click="changeSubCatDesk(0, cat.id)"/>
                        <img onerror="tryReloadImages(this)" v-if="cat.id==-1"  src="/static/imgs/ic_lupa.png" alt="categorias" class="im_categoria2" @click="changeSubCatDesk(0, cat.id)"/>
                        <span style="cursor: pointer;" @click="changeSubCatDesk(0, cat.id)">{{ getInterCatName(cat) }} </span>
                        <!-- SubCats -->
                        <div v-for="(subs, index) in getSubCat(cat.id)" style="display: flex; flex-direction: row; align-items: flex-end;">
                            <span style="color: transparent;">X</span>
                            <span :class="index + 1 == subCatIndex && cat.id == idCat ? 'tx_subcat_sel' : 'tx_subcat'" style="margin-bottom: 0.31vh" @click="changeSubCatDesk(index + 1, cat.id)">{{ subs }}</span>
                        </div>
                        <div style="flex-grow: 1"/>
                        <img onerror="tryReloadImages(this)" v-if="show10Mais" src="/static/imgs/ic_selo10.png" style="object-fit: scale-down; width: 4vh; height: 100%; margin-left: 1.5%; margin-right: 1%;"/>
                    </div>

                    <div style="width: 100%; z-index: 1; display: flex; justify-content: space-between; margin-bottom: -9.5vh;" v-if="!modoMosaico && estabsMat.get(cat.id).length > 0">
                        <div style="width: 5vh; height: 100%; position: relative; z-index: 1; display: flex; align-items: center; justify-content: flex-start; margin-left: -2vh;" @click="scrollEstabs(cat, false, index)">
                            <!--<div :id="'scrollleft' + index" class="seta_estabs" @mouseover="scrollEstabs(cat, false, index, 20)">-->
                            <div :id="'scrollleft' + index" class="seta_estabs">
                                <img src="/static/imgs/ic_left_g.png" style="margin: 0.75vh; object-fit: scale-down; width:3vh; height: 3vh;"/>
                            </div>
                        </div>

                        <div style="width: 5vh; height: 100%; position: relative; z-index: 1; display: flex; align-items: center; justify-content: flex-end; margin-right: -2vh;" @click="scrollEstabs(cat, true, index)">
                            <div :id="'scrollright' + index"  class="seta_estabs">
                            <!--<div :id="'scrollright' + index"  class="seta_estabs" @mouseover="scrollEstabs(cat, true, index, 20)">-->
                                <img src="/static/imgs/ic_right_g.png" style="margin: 0.75vh; object-fit: scale-down; width: 3vh; height: 3vh;"/>
                            </div>
                        </div>
                    </div>

                    <div :id="'scrollhorizontal' + index" :class="modoMosaico ? 'scrollhorizontal-no' : 'scrollhorizontal'">

                        <div v-for="(item, indexj) in estabsMat.get(cat.id)" v-if="estabsMat_ok && (!show10Mais || item.is10Mais)" :class="modoMosaico ? 'destaques-mos': 'destaques'" style="font-size: 2.2vh;">

                            <router-link :to="{ query: { id: item.id }, params: {stabs: estabs_full, categs: cats_full, idCat: idCat, indexCity: cityIndex, subCatIndex: subCatIndex}, name: 'Estabelecimento'}">
                                <div :class="modoMosaico ? 'divDestaques-mos' : 'divDestaques'" v-if="item.tbFotos[0]!=null" style="position: relative;">
                                    <img onerror="tryReloadImages(this)" v-if="item.tbFotos!=null" :src="baseUrlImg + '/MARCADOR/' + item.tbFotos[0].file" alt="Foto Estabelecimento" class="imgDestaques"/><br>
                                    <span v-if="item.is10Mais && show10Mais" class="tx_top_pos"> {{ indexj + 1 }}&ordm; </span>
                                </div>
                            </router-link>

                            <span :style="'font-weight: bold;' + (modoMosaico ? 'max-width: 100%;' : 'max-width: 100%;') + 'overflow: hidden; text-overflow: ellipsis; display: inline-block; margin-bottom: -10px; white-space: nowrap;'" v-html="decodeChars(item.nome)"/>
                            <span :style="'font-size: 2vh; margin-top: 0.5vh;' + (modoMosaico ? 'max-width: 100%;' : 'max-width: 100%;') + 'overflow: hidden; text-overflow: ellipsis; display: inline-block; margin-bottom: -10px; white-space: nowrap;'" v-html="decodeChars(item.cidade)"/>

                            <div :style="'display: flex; flex-direction: row; align-items: center; margin-top:' + (modoMosaico ? 1 : 1.5 ) + 'vh; justify-content: space-between;'">
                                <div class="di_star_wrap" style="with: 10.8vh; max-width: 10.8vh; height: 2vh;" :title="getInterText(inter_ind.avaliacao) + ((item.avaliacao * 100)/5.0)">
                                    <div alt="estrelas" class="im_star" :style="'width: ' + ((item.avaliacao * 100)/5.0) + '%; height: 2vh;'" align="right"/>
                                </div>

                                <div style="display: flex; margin-right: 3%; height: 100%;" @click.prevent.stop="sendFavoriteAvaliacao(item.id, -1)">
                                    <img v-if="user.tipo == 1" src="/static/imgs/ic_edit_sq.png" alt="favoritos" class="im_fav_d_h" @click.prevent.stop="goToEditPage(item, '')" style="margin-right: 20%"/>
                                    <img v-if="loading.favorito" src="/static/imgs/loading5.gif" alt="Carregando" class="im_fav_d_h">
                                    <img v-if="isFavorite(item.id)" src="/static/imgs/ic_favoritos.png" alt="favoritos" class="im_fav_d_h" :title="getInterText(inter_ind.favoritos)"/>
                                    <img v-else src="/static/imgs/ic_favoritos_not.png" alt="favoritos" class="im_fav_d_h" :title="getInterText(inter_ind.favoritos)"/>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>


                <div v-if="cats.length==1 && cats[0].id!=-1 && estabsMat.get(cats[0].id).length==0">
                    <div class="title">
                        <br> <span >{{ tituloCat }} </span>
                    </div>
                    <br><br>
                    <span style="text-align: center"><h4>{{ getInterText(inter_ind.nenhum_estabelecimento) }}</h4></span>
                    <br><br>
                </div>
                <div v-if="search_text.length>=3 && estabsMat.get(-1).length==0">
                    <br>
                    <span style="text-align: center"><h4>{{ getInterText(inter_ind.nenhum_resultado) }}</h4></span>
                    <br><br><br>
                </div>
                <div v-if="search_text.length>0 && search_text.length<3" >
                    <br>
                    <span style="text-align: center"><h4>{{ getInterText(inter_ind.utilize_pelo_menos) }}&nbsp;{{ minSearchLen }}&nbsp;{{ getInterText(inter_ind.caracteres) }}.</h4></span>
                    <br><br><br>
                </div>

                </div>

                <div v-if="loading.cats" style="text-align: center;" >
                    <!--<span class="btn btn-primary btn-sm"  onMouseOver="this.style.cursor='pointer'">Carregar Mais...</span>-->
                    <img src="/static/imgs/loading5.gif" class="im_loading">
                    <!--<img src="/static/imgs/loading2.gif" class="im_loading">-->
                    <br>
                    <br>
                    <br>
                </div>


                <br>

            </div>


            <!--Barra de rodapé -->
            <div class="active">
                <div class="div_pat" v-if="cats.length!=0">
                    <span class="tx_parceiros">{{ getInterText(inter_ind.parceiros) }}</span><br>
                    <a v-for="item in barra_pat" :href="item.url" target=”_blank”><img onerror="tryReloadImages(this)" :src="item.imgPath" class="im_pat"/></a>
                </div>
                <div v-if="cats.length!=0" class="tx_parceiros" style="display: flex; flex-direction: row; justify-content: center; background-color: var(--ligth-gray); padding-bottom: 0.5vh;">
                    <span>&copy; {{ getYear() }} Advice Paraíba |</span>
                    <a href="/static/pages/politicaprivacidade.html"><span>&nbsp;{{ getInterText(inter_ind.politica_privacidade) }}</span></a>
                </div>
            </div>

        </div>

        <div class="div_getPhone" v-if="showGetPhone" @click="getPhoneSair()">
            <div class="getPhone_parts" @click.stop.prevent="nada()">
                <img src="/static/imgs/advicep_horizontal.png" alt="logo advice" class="im10">

                <div style="display: flex; flex-direction: row; width: 100%; justify-content: center; align-items: center;">
                    <img v-if='hasHttp(new_user.foto)'  :src='new_user.foto' alt="profile" class="im_profile">
                    <img v-else :src='baseUrlImg + "PROFILE/" + new_user.foto'     alt="profile" class="im_profile">
                    <span class="getPhone_txt" style="margin-left: 1%;">{{ new_user.nome }}</span>
                </div>
                <span class="getPhone_txt" style="margin-top: -1vh; cursor: pointer;" @click="getPhoneSair()">Não é você? <strong>Sair.</strong></span>

                <span class="getPhone_txt">Digite o seu contato para finalizarmos o seu cadastro.</span>
                <div class="getPhone_input_box">
                    <img src="/static/imgs/ic_tel3.png" style="height: 80%;"/>
                    <input id="telefoneid" class="input_name_getPhone" type="text" v-model="editing[2].texto" v-on:keyup="mphone(editing[2])"/>
                </div>
                <span class="getPhone_txt">O seu telefone não ficará visível para outros usuários.</span>

                <img v-if="loading.phone" src="/static/imgs/loading5.gif" alt="Carregando" class="im_loading_up">
                <div style="display: flex; flex-direction: row; width: 100%; justify-content: space-evenly;">
                    <span class="tx_login4_c" @click="getPhoneSair()">{{ getInterText(inter_ind.cancelar) }}</span>
                    <span class="tx_login4" @click="submitformUserUserPhone()">{{ getInterText(inter_ind.enviar) }}</span>
                </div>
            </div>
        </div>

        <div class="div_login_m" v-if="showLogin" >
            <div class="parts_m">
                <div style="display: flex; justify-content: flex-end; width: 100%; margin-right: -45vw;" @click="setShowLogin(false)">
                    <img src="/static/imgs/bt_fechar_w.png" class="im_close_w" onMouseOver="this.style.cursor='pointer'">
                </div>

                <div style="text-align: center; margin-top: 5vh;">
                    <img src="/static/imgs/advicep_horizontal_w.png" alt="menu" style="height: 8vh">
                </div>


                <!--<div class="div_face_w" style="margin-top: 5vh;" @click="externalLoginFace_checkLoginState()">-->
                    <!--<div class="div_faceim">-->
                        <!--<img src="/static/imgs/ic_face_blue.png" alt="facebook" class="im_face">-->
                    <!--</div>-->

                    <!--<div class="div_facetx">-->
                        <!--<span class="tx_face_m"> {{ getInterText(inter_ind.entre_face) }} </span>-->
                    <!--</div>-->

                    <!--<img v-if="loading.face" src="/static/imgs/loading5.gif" alt="Carregando" class="im_loading_up">-->
                <!--</div>-->



                <!--<div class="div_face_w" style="margin-top: 1vh; margin-bottom: 5vh" @click="externalLoginGoogle_startApp()">-->
                <div class="div_face_w" style="margin-top: 9vh; margin-bottom: 4vh" @click="externalLoginGoogle_startApp()">
                    <div class="div_faceim">
                        <img src="/static/imgs/ic_google.png" alt="facebook" class="im_face">
                    </div>

                    <div class="div_facetx">
                        <span class="tx_face_m unselectable"> {{ getInterText(inter_ind.entre_google) }} </span>
                    </div>

                    <img v-if="loading.google" src="/static/imgs/loading5.gif" alt="Carregando" class="im_loading_up">

                </div>





                <div class="div_nome_l">
                    <!--<span class="tx_nome_before_w" @click="clickInput(1, true)" v-if="!editing[1].status" onMouseOver="this.style.cursor='pointer'" tabindex="2">E-mail</span>-->
                    <!--<div class="hr_w" @click="clickInput(1, true)" onMouseOver="this.style.cursor='pointer'" v-if="!editing[1].status"/>-->
                    <span class="tx_nome_w" v-if="editing[1].status">E-mail</span>
                    <input id="emailid" :class="editing[1].status ? 'input_name_w' : 'input_name_w_d'" type="text" v-model="editing[1].texto" tabindex="3" placeholder="E-mail" @click="clickInput(1, true)" />
                    <span v-if="!checkEmail(editing[1].texto) && editing[1].texto.length>5" class="error_msg">{{ getInterText(inter_ind.email_invalido) }}</span>
                </div>

                <div class="div_nome_l">
                    <!--<span class="tx_nome_before_w" @click="clickInput(0, true)" v-if="!editing[0].status" onMouseOver="this.style.cursor='pointer'"> {{ getInterText(inter_ind.senha) }} </span>-->
                    <!--<div class="hr_w" @click="clickInput(0, true)" onMouseOver="this.style.cursor='pointer'" v-if="!editing[0].status"/>-->
                    <span class="tx_nome_w" v-if="editing[0].status"> {{ getInterText(inter_ind.senha) }} </span>
                    <div style="display: flex; flex-direction: row;">
                        <input id="nameid" :class="editing[0].status ? 'input_name_w' : 'input_name_w_d'" :type='editing[0].show ? "text" : "password"' v-model="editing[0].texto" :placeholder="getInterText(inter_ind.senha)" tabindex="4" @click="clickInput(0, true)"/>
                        <img v-if="editing[0].status" :src='editing[0].show ? "/static/imgs/ic_eye_open_w.png" : "/static/imgs/ic_eye_close_w.png"' style="width: 5vh; object-fit: contain;" @click="showPass(0)">
                    </div>
                    <span v-if="!checkPass(editing[0].texto) && editing[0].texto!=''" class="error_msg">{{ getInterText(inter_ind.senha_errada_2) }}</span>
                </div>

                <div class="div_check" style="margin-top: 4vh;">
                    <div class="div_check_in" @click="changeCheckState(0)">
                        <span v-if="valid.enterAuto" class="tx_checkbox">&#10003;</span>
                    </div>
                    <span class="tx_check" style="flex-grow: 1">{{ getInterText(inter_ind.entrar_auto) }}</span>
                    <span class="tx_check" style="cursor: pointer;" @click="goToEditUser">{{ getInterText(inter_ind.esqueceu_senha) }}</span>
                </div>

                <span v-if="senhaErrada" class="error_msg"> {{ getInterText(inter_ind.senha_errada) }} </span>
                <div style="text-align: center;">
                    <span v-if="userNaoCadastrado" class="error_msg"> {{ getInterText(inter_ind.usuario_nao_cadastrado) }}</span>
                </div>


                <img v-if="loading.user" src="/static/imgs/loading5.gif" alt="Carregando" class="im_loading_up">

                <div style="display: flex; flex-direction: row; margin-top: 8vh;">
                    <div class="div_botao_login" style="margin-right: 2vw; background-color: white;" @click="tryLogin()" onMouseOver="this.style.cursor='pointer'" tabindex="4">
                        <span class="tx_continuar_w unselectable" style="color: var(--bg-blue);"> {{ getInterText(inter_ind.entrar) }} </span>
                    </div>
                    <router-link :to="{ params: { stabs: estabs_full, categs: cats_full, idCat: idCat}, name: 'registerUser'}">
                        <div class="div_botao_login">
                            <span class="tx_continuar_w unselectable" style="font-weight: normal;"> {{ getInterText(inter_ind.cadastre) }} </span>
                        </div>
                    </router-link>
                </div>
            </div>
        </div>

        <filter id="colorize" color-interpolation-filters="sRGB">
            <feColorMatrix type="matrix" values=
                "0 0 0 0 0.18
                 0 0 0 0 0.24
                 0 0 0 0 0.31
                 0 0 0 1 0"/>
        </filter>

        <filter id="colorize_blue" color-interpolation-filters="sRGB">
            <feColorMatrix type="matrix" values=
                "0 0 0 0 0.207
                 0 0 0 0 0.333
                 0 0 0 0 0.529
                 0 0 0 1 0"/>
        </filter>

        <Alert v-if="showAlert || showConfirm" :textProp="textAlert" :confirmProp="showConfirm" @emit-close="closeAlert" @emit-action="actionFunction"/>

        <div class="overlay" @click="changeSideBar()"></div>

    </div>
</template>

<script>
    import axios from 'axios'
    import { advMixin } from '../scripts/advMixin'
    import SideMenu from '@/components/templates/SideMenu.vue'

    export default {
        mixins: [advMixin],
        name: 'Home',
        data () {
            return {
                name: 'Home',
                estabsMat: {},
                estabsMat_ok: false,
                estabs: [],
                cats: [],
                estabs_full: [],
                estabs_search: [],
                cats_full: [],
                idCat: 0,
                search_text: "",
                showingSearch: false,
                searching: false,
                response: {
                    status: "ok"
                },
                tituloCat: "Destaques",
                corCat: "#96989b",
                panoInd: 0,
                pano: [
                    {
                        imgPath: "static/imgs/pano_d2_01.jpg",
                        shift: 0,
                        shift_m: 0
                    },
                    {
                        imgPath: "static/imgs/pano_d2_02_.jpg",
                        shift: 0,
                        shift_m: 0
                    },
                    {
                        imgPath: "static/imgs/pano_d2_03.jpg",
                        shift: 0,
                        shift_m: 0
                    },
                    {
                        imgPath: "static/imgs/pano_d2_04.jpg",
                        shift: 0,
                        shift_m: 0
                    },
                    {
                        imgPath: "static/imgs/pano_d2_05.jpg",
                        shift: 0,
                        shift_m: 0
                    },
                    {
                        imgPath: "static/imgs/pano_d2_06.jpg",
                        shift: 0,
                        shift_m: 0
                    },
                    {
                        imgPath: "static/imgs/pano_d2_07.jpg",
                        shift: 0,
                        shift_m: 0
                    },
                    {
                        imgPath: "static/imgs/pano_d2_08.jpg",
                        shift: 0,
                        shift_m: 0
                    },{
                        imgPath: "static/imgs/pano_d2_09.jpg",
                        shift: 0,
                        shift_m: 0
                    }
                    // {
                    //     imgPath: "static/imgs/pano_d_01.jpg",
                    //     shift: 0,
                    //     shift_m: 0
                    // },
                    // {
                    //     imgPath: "static/imgs/pano_d_02.jpg",
                    //     shift: 0,
                    //     shift_m: 0
                    // },
                    // {
                    //     imgPath: "static/imgs/pano_d_03.jpg",
                    //     shift: 0,
                    //     shift_m: 0
                    // },
                    // {
                    //     imgPath: "static/imgs/pano_d_04.jpg",
                    //     shift: 0,
                    //     shift_m: 0
                    // },
                    // {
                    //     imgPath: "static/imgs/pano_d_05.jpg",
                    //     shift: 0,
                    //     shift_m: 0
                    // },
                    // {
                    //     imgPath: "static/imgs/pano_d_06.jpg",
                    //     shift: 0,
                    //     shift_m: 0
                    // },
                    // {
                    //     imgPath: "static/imgs/pano_d_07.jpg",
                    //     shift: 0,
                    //     shift_m: 0
                    // },
                    // {
                    //     imgPath: "static/imgs/pano_d_08.jpg",
                    //     shift: 0,
                    //     shift_m: 0
                    // },
                    // {
                    //     imgPath: "static/imgs/pano_d_09.jpg",
                    //     shift: 0,
                    //     shift_m: 0
                    // },
                ]
            }
        },
        methods: {
            getPanoImg() {
                return this.pano[this.panoInd].imgPath;
            },
            shuffle(array) {
                var tmp, current, top = array.length;
                if(top) while(--top) {
                    current = Math.floor(Math.random() * (top + 1));
                    tmp = array[current];
                    array[current] = array[top];
                    array[top] = tmp;
                }
                return array;
            },
            closeKey() {
                console.log('closeKeyboard');
                this.$refs.search_i.blur();
            },
            adjustCaracterEncoding() {
                var i;
                var vm = this;
                for (i=0 ; i<vm.estabs_full.length ; i++) {
                    try {
                        vm.estabs_full[i].nome = decodeURIComponent(escape(vm.estabs_full[i].nome));
                    } catch (e) {
                        vm.estabs_full[i].nome = unescape(vm.estabs_full[i].nome);
                    }
                    try {
                        vm.estabs_full[i].horario = decodeURIComponent(escape(vm.estabs_full[i].horario));
                    } catch (e) {
                        vm.estabs_full[i].horario = unescape(vm.estabs_full[i].horario);
                    }
                    try {
                        vm.estabs_full[i].responsavel = decodeURIComponent(escape(vm.estabs_full[i].responsavel));
                    } catch (e) {
                        vm.estabs_full[i].responsavel = unescape(vm.estabs_full[i].responsavel);
                    }
                    try {
                        vm.estabs_full[i].rua_num = decodeURIComponent(escape(vm.estabs_full[i].rua_num));
                    } catch (e) {
                        vm.estabs_full[i].rua_num = unescape(vm.estabs_full[i].rua_num);
                    }
                    try {
                        vm.estabs_full[i].bairro = decodeURIComponent(escape(vm.estabs_full[i].bairro));
                    } catch (e) {
                        vm.estabs_full[i].bairro = unescape(vm.estabs_full[i].bairro);
                    }
                    try {
                        vm.estabs_full[i].cidade = decodeURIComponent(escape(vm.estabs_full[i].cidade));
                    } catch (e) {
                        vm.estabs_full[i].cidade = unescape(vm.estabs_full[i].cidade);
                    }
                }
            },
            goToEditUser() {
                window.location.href = 'https://www.adviceparaiba.com/EditUser';
            },
            getEstabsSearch() {
                console.log('getEstabsSearch ' + this.search_text);

                this.estabs_search = [];

                this.cats = [
                    {
                        nome: this.inter_pt[this.inter_ind.resultado_busca],
                        nomeEn: this.inter_en[this.inter_ind.resultado_busca],
                        nomeEs: this.inter_es[this.inter_ind.resultado_busca],
                        id: -1
                    }
                ];

                if (this.search_text.length > 0) {
                    this.searching = true;
                }

                if (this.search_text.length < this.minSearchLen) {
                    console.log('getEstabsSearch::nao vou buscar: ' + this.search_text, this.search_text.length);

                    if (this.search_text.length === 0) {

                        this.cats = this.cats_full;
                        this.modoMosaico = false;
                        this.searching = false;
                    }
                    return ;
                }

                var search_text2 = this.search_text.toLowerCase();
                var i;
                for (i=0 ; i<this.estabs_full.length ; i++) {
                    var estab = this.estabs_full[i];

                    if (estab.ativo && estab.aprovado) {
                        if (estab.nome.toLowerCase().indexOf(search_text2) >= 0 ||
                            estab.bairro.toLowerCase().indexOf(search_text2) >= 0 ||
                            estab.descricao2.toLowerCase().indexOf(search_text2) >= 0) {
                            this.estabs_search.push(estab);
                            console.log('search: ' + estab.nome);
                        }
                        else {
                            var j;
                            for (j = 0; j < estab.tbCategoriaEstabelecimentos.length; j++) {
                                var catt = estab.tbCategoriaEstabelecimentos[j];
                                if (catt.nome.toLowerCase().indexOf(search_text2) >= 0) {
                                    this.estabs_search.push(estab);
                                    console.log('search: ' + estab.nome);
                                    break;
                                }
                            }
                        }
                    }
                }

                this.modoMosaico = this.estabs_search.length > 0;

                this.estabsMat.set(-1, this.estabs_search);
            },
            // getEstabs(idCat) {
            //     console.log('getEstabs ' + idCat);
            //     var vm = this;
            //
            //     var estabs = [];
            //
            //     if (idCat==-1) {
            //         estabs = this.estabs_search;
            //     }
            //     else {
            //         var i;
            //         for (i = 0; i < vm.estabs_full.length; i++) {
            //             var estab = vm.estabs_full[i];
            //
            //             var j;
            //             for (j = 0; j < estab.tbCategoriaEstabelecimentos.length; j++) {
            //                 var cat = estab.tbCategoriaEstabelecimentos[j];
            //                 if (cat.id == idCat && (this.cityIndex == 0 || estab.cidade == this.city_full[this.cityIndex].nome) && estab.ativo && estab.aprovado) {
            //                     estabs.push(estab);
            //                 }
            //             }
            //         }
            //     }
            //
            //     this.estabs = estabs;
            //
            //     return estabs;
            // },
            // hasEstabs(idCat) {
            //     console.log('hasEstabs ' + idCat);
            //     var vm = this;
            //
            //     var estabs = [];
            //
            //     if (idCat==-1) {
            //         estabs = this.estabs_search;
            //     }
            //     else {
            //         var i;
            //         for (i = 0; i < vm.estabs_full.length; i++) {
            //             var estab = vm.estabs_full[i];
            //
            //             var j;
            //             for (j = 0; j < estab.tbCategoriaEstabelecimentos.length; j++) {
            //                 var cat = estab.tbCategoriaEstabelecimentos[j];
            //                 if (cat.id == idCat && (this.cityIndex == 0 || estab.cidade == this.city_full[this.cityIndex].nome) && estab.ativo && estab.aprovado) {
            //                     return true;
            //                 }
            //             }
            //         }
            //     }
            //
            //     return false;
            // },
            atualizaEstabsToggle(idCatAtual) {
                if (this.subCatIndex > 0) {
                    this.subCatIndex = 0;
                    this.generateEstabsMat();
                }

                this.search_text = ''

                if (this.modoMosaico) {
                    this.atualizaEstabs(0);
                } else {
                    window.scrollTo(0,0);
                    this.atualizaEstabs(idCatAtual);
                }
            },
            atualizaEstabs(idCatAtual) {
                console.log('atualizaEstabs id: ' + idCatAtual);
                var vm = this;

                if (idCatAtual==0) {
                    vm.cats = vm.cats_full;
                    console.log('cats:');
                    console.log(vm.cats);
                    this.modoMosaico = false;

                    if (this.subCatIndex > 0) {
                        //this.subCatIndex = 0;
                        this.generateEstabsMat();
                    }
                }
                else {
                    // vm.estabs = [];
                    this.restartCats(idCatAtual);

                    this.modoMosaico = true;
                }


                $('#sidebar').removeClass('active');
                $('.overlay').fadeOut();
                $('#icmenu').removeClass('open');
            },
            atualizaParametros() {
                console.log('atualizaParametros');
                console.log(this.$route.query);

                if (this.$route.query.idCat != null) {
                    this.idCat = this.$route.query.idCat;
                    console.log('1::id eh valido ' + this.idCat);
                }
                else if (this.$route.params.idCat != null) {
                    this.idCat = this.$route.params.idCat;
                    console.log('2::id eh valido ' + this.idCat);
                }
                else {
                    // this.tituloCat = "Destaques";
                    this.idCat = 0;
                    // this.corCat = "#96989b";
                    console.log('id eh nulo');
                }

                this.getCities();

                this.atualizaEstabs(this.idCat);

                // gera a matriz de estabelecimentos.
                this.generateEstabsMat();
            },

            trimAll(str){
                return str.replace(/\s/g,'');
            }
        },
        components: {
            SideMenu: SideMenu
        },
        created() {
            console.log('Home::created!!');

            if (this.$route.params.login) {
                this.setShowLogin(true);
            }

            console.log('antes do validate: ')
            console.log('this.$route.query: ', this.$route.query)
            console.log('this.$route.query.ver: ', this.$route.query.ver)
            console.log('this.$route.query.idu: ', this.$route.query.idu)
            // Faz a validacao do e-mail do usuario.
            if (this.$route.query.idu != null && this.$route.query.ver != null) {
                // idu=id_user&ver=verification_code
                this.validadeEmail(this.$route.query.idu, this.$route.query.ver)
            }

            // if (this.$route.params.user) {
            //     this.user = this.$route.params.user;
            // }

            if (this.$route.params.indexCity != null) {
                this.cityIndex = this.$route.params.indexCity;
                console.log('setando o cityIndex para: ', this.cityIndex);
            }

            if (this.$route.params.subCatIndex != null) {
                this.subCatIndex = this.$route.params.subCatIndex;
                console.log('setando o subCatIndex para: ', this.subCatIndex);
            }

            if (this.$route.params.idCat != null) {
                this.idCat = this.$route.params.idCat;
                console.log('setando o idCat para: ', this.idCat);
            }

            if (this.$route.params.stabs) {
                console.log('Usando estabs e cats passados por parametro!!');
                this.estabs_full = this.$route.params.stabs;
                this.cats_full = this.$route.params.categs;

                console.log('this.$route.params.dezMais: ', this.$route.params.dezMais);
                if (this.$route.params.dezMais != null)
                    this.show10Mais = this.$route.params.dezMais;

                this.atualizaParametros();
            }
            else {
                console.log('Baixando estabs!!');
                this.getEstabsCatsHome();
            }

            if (this.$route.params.anuncios) {
                console.log('Usando anuncios passados por parametro!!');
                this.anuncios = this.$route.params.anuncios;
            }
            else {
                console.log('Baixando estabs!!');
                this.getAnuncios();
            }

            console.log('Home::subCatIndex: ', this.subCatIndex);
            console.log('Home::idCat: ', this.idCat);

            console.log('Home::Terminei o created!!');
        },
        beforeMount() {
            console.log('beforeMount!!');

            console.log('Terminei o beforeMount!!');
        },
        mounted() {
            console.log('mounted!!');

            // $(document).ready(function () {
                // $('#dismiss, .overlay').on('click', function () {
                //     $('#sidebar').removeClass('active');
                //     $('.overlay').fadeOut();
                //     $('#div_pat_s').fadeOut(0);
                // });

                // $('#sidebarCollapse').on('click', function () {
                //     $('#div_pat_s').fadeIn();
                //     $('#sidebar').addClass('active');
                //     $('.overlay').fadeIn();
                //     $('.collapse.in').toggleClass('in');
                //     $('a[aria-expanded=true]').attr('aria-expanded', 'false');
                // });
            // });

            // $('#div_pat_s').fadeOut(0);

            this.barra_pat = this.shuffle(this.barra_pat);

            // this.panoInd = (this.panoInd + 1) % 5;
            this.panoInd = Math.floor(Math.random() * 5);
            // this.panoInd = 0;

            if (this.user.idioma > 0) {
                this.changeIdioma(this.user.idioma);
            }

            console.log('Terminei o mounted!!');
        },

    }



</script>
<!-- PullToRefresh.js script -->
<!--<script src="https://cdnjs.cloudflare.com/ajax/libs/pulltorefreshjs/0.1.22/pulltorefresh.min.js"></script>-->

<style src="../assets/css/menu_icon.css" scoped/>
<style src="../assets/css/advDesk.css" scoped/>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .roothome {
        /*background-color: #f0f0f0;*/
        background-color: var(--main-bg-color-new);
        overflow-y: scroll;
    }
    .roothome::-webkit-scrollbar {
        /* This is the magic bit */
        display: none;
    }

    .im_social {
        display: inline-block;
        /*width: 35px;*/
        /*width: 2.6vw;*/
        height: 90%;
        width: 100%;
        margin-top: 0.2vh;
        /*padding: 3px;*/
        object-fit: scale-down;
        /*padding: 0.1vw;*/
        vertical-align: middle;
    }
    .bar_idiomas {
        display: flex;
        flex-direction: row;
        vertical-align: middle;
        /*background-color: red;*/
        /*padding-left: 1vw;*/
        align-items: center;
        justify-content: space-evenly;
        background-image: url('/static/imgs/ic_barra_idiomas_w.png');
        /*background-size: auto 100%;*/
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
        width: 100%;
        height: 3.5vh;
    }
    .bar_cidades {
        display: flex;
        /*vertical-align: middle;*/
        /*background-color: red;*/
        /*padding-left: 1vw;*/
        align-items: center;
        justify-content: space-evenly;
        background-image: url('/static/imgs/ic_barra_idiomas_w.png');
        /*background-size: auto 100%;*/
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
        /*width: 100%;*/
        width: 26vh;
        height: 3.5vh;
    }
    .im100 {
        /*width: 100%;*/
        width: 49.5vw;
        vertical-align: middle;
    }
    .im100_search {
        width: 100%;
        height: 100%;
        vertical-align: middle;
        position: relative;
        object-fit: cover;
        /*background-color: red;*/
        /*clip: rect(0px,0px,100%,100%);*/
        /*height: 275px;*/
        /*margin-right: 100px;*/
        /*object-fit: cover;*/
    }

    .im_star {
        position: relative;
        height: 100%;
        background-image: url('/static/imgs/ic_estrela_filled.png');
        background-repeat: no-repeat;
        /*background-size: cover;*/
        background-size: auto 100%;
    }
    .di_star_wrap {
        /*background-color: blue;*/
        background-image: url('/static/imgs/ic_estrela_empty.png');
        background-repeat: no-repeat;
        background-size: contain;
        display: flex;
        position: relative;
        max-width: 11vw;
        width: 11vw;
        height: 2vw;

    }

    .divDestaques {
        display: inline-block;
        /*width: 200px;*/
        /*width: 24vh;*/
        /*height: 150px;*/
        /*height: 18vh;*/
        width: 100%;
        height: var(--home-estab-height);
    }
    .divDestaques-mos {
        /*margin-right: 1vh;*/
        /*margin-left: 1vh;*/
        display: inline-block;
        width: 100%;
        height: var(--home-estab-mos-height);
    }
    .imgDestaques {
        object-fit: cover;
        width: 100%;
        height: 100%;
        background-color: var(--empty-color);
    }
    .destaques, .destaques-mos {
        /*background-color: green;*/
        text-align: left;
        display: inline-block;
        /*margin-left: 3%;*/
        /*margin-right: 15px;*/
        margin-bottom: 30px;/*Precisa disso para não ficar com um scroll vertical dentro do horizontal.*/
    }

    .destaques {
        display: flex;
        flex-direction: column;
        /*background-color: red;*/
        flex-grow: 1;
        flex-shrink: 0;
        /*flex-basis: 14.7%;*/
        /*max-width: 14.7%;*/
        /*margin-right: 2%;*/

        flex-basis: 18.05%;
        max-width: 18.05%;
        margin-right: 2%;
    }

    .destaques-mos {
        display: flex;
        flex-direction: column;
        margin-left: 0;
        margin-right: 0;
        /*justify-content: flex-start;*/
        flex-grow: 1;
        flex-basis: 24.2%;
        max-width: 24.2%;
        margin-bottom: 4vh;
        margin-right: 0.8%;
        /*background-color: red;*/
    }
    .scrollhorizontal {
        /*background-color: red;*/
        display: flex;
        overflow-x: scroll;
        white-space: nowrap;
        justify-content: flex-start;
    }
    .scrollhorizontal-no {
        /*background-color: red;*/
        overflow-x: unset;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        justify-content: flex-start;
        margin-top: -5vh;
    }
    .scrollhorizontal::-webkit-scrollbar {
        /* This is the magic bit */
        display: none;
    }
    .search {
        background-image: url('/static/imgs/bg_search01.png');
        background-color: transparent;
        background-repeat: no-repeat;
        /*background-size: contain;*/
        background-size: 100% 28px;
        border: none;
        outline:none;
        /*position: center;*/
        position: relative;
        margin-top: -10px;
        padding-left: 50px;
        width: 100%;
        height: 28px;
        max-width: 662px;
    }

    .search2 {
        border: none;
        outline:none;
        /*position: center;*/
        position: relative;
        width: 100%;
        font-size: 2.5vh;
        /*height: 28px;*/
    }


    .title, .title3 {
        text-align: center;
        font-size: 30px;
    }

    .title2 {
        height: var(--home-panorama-height);
        max-height: var(--home-panorama-height);
        text-align: center;

        margin-top: var(--top-bar-heigth_desk);

        /*background-color: red;*/
    }
    .title2_2 {
        width: 100%;
        height: 100%;
        overflow-y: hidden;
        margin-bottom: -10px;
        margin-bottom: -0.5vh;
    }

    .title3, .title3_v2 {
        display: flex;
        text-align: left;

        font-family: 'Humanst521BT';

        font-size: var(--font-size-title);
        background-color: white;
        border-radius:10px;
        margin-right: 1%;
        margin-left: 1%;
        margin-bottom: 6.5vh;

        height: 5.5vh;
        align-items: center;
        align-content: center;
        justify-content: left;
    }

    .title3_v2 {
        margin-right: 0;
        margin-left: 0;

        border-radius: unset;

        border-bottom-color: var(--ligth-gray);
        border-bottom-style: solid;
        border-bottom-width: 0.2vh;
    }

    .im_loading {
        width: 80px;
        height: 80px;
        display: inline-block;
    }
    .im_categoria2 {
        /*width: 30px;*/
        /*height: 30px;*/
        width: var(--cat-img-width);
        height: var(--cat-img-height);
        /*margin-left:17px;*/
        margin-right: 0.4%;
        /*object-fit: scale-down;*/
        object-fit: contain;
        filter: url(#colorize_blue);
        /*background-color: red;*/

        /* Tira o embasado.*/
        -webkit-backface-visibility: hidden;
        -ms-transform: translateZ(0); /* IE 9 */
        -webkit-transform: translateZ(0); /* Chrome, Safari, Opera */
        transform: translateZ(0);

        cursor: pointer;
    }
    .im_pat {
        height: 1.34cm;
        margin-left: 0.75cm;
        margin-right: 0.75cm;
        margin-bottom: 0.75cm;
        margin-top: 0.5cm;
        object-fit: contain;
    }
    .div_pat {
        position: page;
        bottom: 0;
        /*background-color: #949494;*/
        /*background-color: #C4C4C4;*/
        /*background-color: #CDCDCD;*/
        background-color: var(--ligth-gray);
        padding-top: 0.25cm;
        /*background-color: #E4E4E4;*/
        text-align: center;
    }
    .tx_parceiros {;
        font-size: 12pt;
        /*color: #040505;*/
        color: #858585;
    }
    .im_pat_s {
        height: 0.7cm;
        margin-left: 0.2cm;
        margin-right: 0.2cm;
        margin-bottom: 0.2cm;
        margin-top: 0.2cm;
    }
    .div_pat_s {
        width: 250px;
        padding-top: 0.15cm;
        /*position: absolute;*/
        position: fixed;
        display: inline-block;
        vertical-align: bottom;
        top: auto;
        left: 0;
        bottom: 0px;
        z-index: 999;
        /*background-color: #E4E4E4;*/
        /*background: #549CCB;*/
        background-color: #CDCDCDBB;
        text-align: center;
    }

    .div_login {
        background: rgba(0, 0, 0, .7);
        flex-direction: column;
        display: flex;
        justify-content: center;
        position: fixed;
        align-items: center;
        top: 0;
        width: 100vw;
        height: 100vh;
        overflow-x: auto;
        z-index: 3;
    }


    .parts {
        background: white;
        box-shadow: 5px 5px 5px black;
        width: 35vw;
        height: 50vh;
        display: flex;
        padding: 5vh;
        padding-top: 1vh;
        align-items: center;
        flex-direction: column;
    }

    .tx_parceiros_s {;
        font-size: 9pt;
        /*color: #040505;*/
        color: #858585;
    }

    .tx_login4, .tx_login4_c {
        font-size: 3vh;
        border-radius:50px;
        padding-top: 1%;
        padding-bottom: 1%;
        padding-right: 10%;
        padding-left: 10%;
        width: 30%;
        text-align: center;
        display: flex;
        justify-content: center;
        cursor: pointer;
    }
    .tx_login4_c {
        background-color: transparent;
        color: var(--bg-round-rect1);
        border-color: var(--bg-round-rect1);
        border-style: solid;
        border-width: 1px;
    }

    .dv_search {
        background-color: white;
        width: 30%;
        /*height: 7vh;*/
        height: calc(var(--home-panorama-height) * 0.2);
        display: flex;
        position: absolute;
        margin-top: 30vh;
        margin-top: calc(var(--home-panorama-height) * 0.9);
        padding-right: 1%;
        padding-left: 2%;
        flex-direction: row;
        align-items: center;

        border-radius: 50px;
        border-width: 1px;
        border-color: #DDDDDD;
        border-style: solid;
    }

    .im_search {
        width: 3.5vh;
        height: 3.5vh;
        width: calc(var(--home-panorama-height) * 0.1);
        height: calc(var(--home-panorama-height) * 0.1);
        /*background-color: red;*/
        object-fit: contain;
    }

    .div_face, .div_face_w {
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 2vh;
        width: 100%;
        display: flex;
        -webkit-border-radius: 7px;
        -moz-border-radius: 7px;
        border-radius: 7px;
        border-width: 1px;
        border-style: solid;
        border-color: var(--bg-blue);
        justify-content: center;
    }

    /*.div_face_w {*/
        /*width: 80%;*/
        /*padding: 1vh;*/
        /*background: white;*/
        /*-webkit-border-radius: 4px;*/
        /*-moz-border-radius: 4px;*/
        /*border-radius: 4px;*/
    /*}*/
    .div_face_w {
        display: flex;
        flex-direction: row;
        align-items: center;

        display: flex;
        border-width: 1px;
        border-style: solid;
        border-color: var(--bg-blue);
        justify-content: center;

        width: 90%;
        padding-right: 1.5vw;
        padding-left: 1.5vw;
        padding-top: 2.5vh;
        padding-bottom: 2.5vh;
        background: white;
        -webkit-border-radius: 4px;
        -moz-border-radius: 4px;
        border-radius: 4px;
        cursor: pointer;
    }

    /*.div_faceim {*/
        /*!*background: pink;*!*/
        /*display: flex;*/
        /*justify-content: center;*/
        /*flex-basis: 0;*/
        /*flex-grow: 1;*/
    /*}*/
    .div_faceim {
        /*background: pink;*/
        display: flex;
        justify-content: center;
        flex-basis: 0;
        flex-grow: 1;
    }

    .im_face {
        /*background: red;*/
        display: flex;
        width: 4vh;
        height: 4vh;
        -webkit-filter: brightness(150%);
        filter: brightness(150%);
    }

    .div_facetx {
        /*background: brown;*/
        display: flex;
        justify-content: center;
        flex-grow: 1;
    }


    .input_name_getPhone {
        background-color: transparent;
        background-repeat: no-repeat;
        background-size: 100% 28px;
        position: relative;
        width: 100%;
        border: none;
        outline: none;
        height: 80%;
        /*background-color: red;*/
        font-size: 3.5vh;
    }

    .input_name_m {
        color: white;
        border-bottom: 2px solid white;
    }


    .div_botao, .div_botao_t {
        display: flex;
        align-items: center;
        padding: 2vh;
        width: 80%;
        display: flex;
        color: white;
        background: var(--bg-blue);
        -webkit-border-radius: 7px;
        -moz-border-radius: 7px;
        border-radius: 7px;
        border-width: 1px;
        border-style: solid;
        border-color: var(--bg-blue);

        justify-content: center;
        margin-top: 5vh;
    }

    .div_botao_t {
        background: unset;
        border-color: rgba(255, 255, 255, .7);
        padding: 1vh;
    }


    /*.tx_continuar {*/
        /*font-size: 15pt;*/
        /*font-weight: bold;*/
        /*color: white;*/
        /*font-style: normal;*/
        /*text-align: center;*/
        /*display: flex;*/
    /*}*/
    .tx_continuar {
        display: flex;
        flex-direction: row;
        font-weight: normal;
        color: unset;
        font-size: 2.5vh;
        /*font-family: 'Humanst521LTBT', Helvetica, Arial,sans-serif;*/
    }

    .im_close {
        display: flex;
        justify-self: flex-end;
        align-self: flex-end;
        width: 30px;
        height: 30px;
        margin-right: -4vh;
    }

    .div_botao, .div_botao_t_b, .div_botao_t_w, .div_botao_m {
        display: flex;
        align-items: center;
        padding: 2vh;
        width: 80%;
        display: flex;
        color: white;
        background: var(--bg-blue);
        -webkit-border-radius: 7px;
        -moz-border-radius: 7px;
        border-radius: 7px;
        border-width: 1px;
        border-style: solid;
        border-color: var(--bg-blue);
        justify-content: center;
        margin-top: 1vh;
    }

    .div_botao_m {
        margin-top: 8vw;
        padding: 2vw;
    }

    .div_botao_t_w {
        background: unset;
        border-color: rgba(255, 255, 255, .7);
        padding: 1vh;
        color: white;
        width: 80%;
    }

    .div_botao_t_w {
        border-style: none;
        background: white;
        padding: 1.3vh;
        height: 5vh;
        color: var(--bg-blue);
    }

    .div_botao_t {
        display: flex;
        align-items: center;
        width: 80%;
        display: flex;
        color: white;
        background: var(--bg-blue);
        -webkit-border-radius: 7px;
        -moz-border-radius: 7px;
        border-radius: 7px;
        border-width: 1px;
        border-style: solid;
        border-color: var(--bg-blue);
        justify-content: center;
        margin-top: 1vh;
    }

    .div_botao_t {
        background: unset;
        border-color: rgba(255, 255, 255, .7);
        padding: 1.3vh;
        height: 5vh;
        color: white;
        cursor: pointer;
        width: 80%;
    }

    .div_botao_t:active {
        border-color: var(--bg-blue);
        background: white;
        color: var(--bg-blue);
    }

    .div_botao_t.tx_continuar:active {
        color: var(--bg-blue);
    }

    .custom-select-filtro {
        width: 60%;
        height: 4.5vh;
        background-color: var(--bg-blue-grad1);
        border-color: transparent;
        border-width: 1px;
        border-style: solid;
        text-align: center;

        margin-right: 2.5%;
        margin-left: 2.5%;
        margin-top: 1.5vh;
        margin-bottom: -1.5vh;

        display: flex;
    }

    select#sel_cats {
        margin-left: 2vw;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;       /* Remove default arrow */
        outline: none;
        background-color: var(--bg-blue-grad1);
        /*background-color: red;*/
        display: flex;
        align-items: center;
        justify-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        border: none;
        padding-left: 2%;
        /*font-size: 12pt;*/
        font-size: 2vh;
    }

    select#sel_cats2 {
        margin-left: 2vw;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;       /* Remove default arrow */
        outline: none;
        background-color: var(--bg-blue-grad1);
        /*background-color: unset;*/
        color: white;
        display: flex;
        align-items: center;
        justify-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        border: none;
        padding-left: 2%;
        /*font-size: 12pt;*/
        font-size: 2vh;
    }

    select#sel_cats2::selection {
        background-color: purple;
    }

    .hr_pat {
        width: 85%;
        margin-top: 0;
        margin-bottom: 5%;
        color: white;
        background-color: white;
        border-color: white;
    }


    .im_pat_m {
        /*background-color: #0f62ac;*/
        width: 85%;
        /*margin-right: 2%;*/
        /*margin-bottom: 2%;*/

    }

    .div_pat_m {
        position: page;
        bottom: 0;
        width: 100%;
        display: inline-block;
        padding-top: 0;
        text-align: center;
        background-color: transparent;
        width: 100%;
        height: 6%;
        flex-grow: 10;
        flex-shrink: 0;
    }

    #dismiss {
        top: 0;
        left: 0;
        margin-left: 5px;
        margin-top: 10px;
    }


    /****************** Login window *****************/
    .div_login_m, .div_getPhone {
        /*background: rgba(1, 0, 0, .7);*/
        /*background: blue;*/
        flex-direction: column;
        display: flex;
        justify-content: center;
        position: fixed;
        align-items: center;
        top: 0;
        width: 100vw;
        height: 100vh;
        overflow-x: auto;
        overflow-y: auto;
        z-index: 1000;
    }

    .div_getPhone {
        z-index: 2000;
        background-color: #000000BB;
    }

    .parts_m {
        /*background-color: mediumblue;*/
        background-color: blue;
        background-image: url('/static/imgs/bg_login_d.jpg');
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
        /*background: red;*/
        /*box-shadow: 5px 5px 5px black;*/
        width: 100vw;
        height: 100vh;
        /*height: max-content;*/
        display: flex;
        /*padding: 8vw;*/
        padding-top: 1vw;
        align-items: center;
        overflow-y: auto;
        flex-direction: column;
        padding-right: 30vw;
        padding-left: 30vw;
    }

    .tx_nome, .tx_nome_before, .tx_nome_before_w, .tx_nome_w {
        display: flex;
        width: 100%;
        font-size: 25pt;
        /*color: gray;*/
    }

    .tx_nome_w {
        color: white;
        font-size: 3vh;
        font-weight: bold;
    }

    .tx_nome_before_w {
        color: white;
        font-family: 'Humanst521BT';
        font-size: 3.5vh;
    }

    .hr, .hr_w {
        width: 100%;
        height: 2px;
        margin-top: 5px;
        background: gray;
    }

    .hr_w {
        background-color: white;
    }

    .error_msg {
        font-family: 'Humanst521BT';
        color: red;
        font-size: 2.5vh;
    }

    .div_check {
        display: flex;
        width: 100%;
        margin-top: 0;
        align-items: center;
    }

    .div_check_in {
        display: flex;
        border-width: 2px;
        border-style: solid;
        border-color: white;
        width: 15px !important;
        height: 15px !important;
        -webkit-border-radius: 2px;
        -moz-border-radius: 2px;
        border-radius: 2px;
        cursor: pointer;
    }

    .tx_checkbox {
        color: white;
        font-weight: bold;
        margin-top: -4px;
    }

    .tx_check {
        color: white;
        font-style: normal;
        text-align: center;
        display: flex;

        font-weight: normal;
        display: flex;
        font-size: 9pt;
        font-size: 2.5vh;
        margin-left: 1.5vw;

        justify-items: flex-end;
        align-content: flex-end;
        alignment-baseline: bottom;
    }

    .div_botao_login {
        border-style: solid;
        border-color: white;
        border-width: 1px;
        width: 15vw;
        height: 5vh;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 3px;
        /*background: white;*/

        color: white;
    }

    .im_fav_d_h {
        /*background-color: red;*/
        height: 1.1vw;
        cursor: pointer;
    }

    .seta_estabs {
        background-color: #FFFFFF55;
        width: 4.5vh;
        height: 4.5vh;
        border-radius: 50%;
        /*border: #FFFFFF55;*/
        /*border-width: 1px;*/
        border-style: none;
    }

    .seta_estabs:hover {
        background-color: #BBBBBB77;
        /*border: #BBBBBB77;*/
    }
    .noScrollMenu {
        scrollbar-width: none;
        -ms-overflow-style: none;
    }
    .noScrollMenu::-webkit-scrollbar {
        width: 0px; /* For Chrome, Safari, and Opera */
        display: none;
    }

    .getPhone_input_box {
        border-color: var(--gray-phone);
        border-width: 2px;
        border-style: solid;
        border-radius: 15px;
        width: 80%;
        height: 6vh;
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .getPhone_txt {
        color: var(--bg-blue-circle);
        font-size: 3vh;
        text-align: center
    }

    .getPhone_parts {
        background-color: white;
        width: 60%;
        height: 65%;
        /*height: max-content;*/
        display: flex;
        padding: 2vh;
        padding-right: 5%;
        padding-left: 5%;
        padding-top: 5vh;
        padding-bottom: 5vh;
        align-items: center;
        justify-content: space-between;
        flex-direction: column;
        -webkit-box-shadow: 0 0 3px #AAAAAADD;
        -moz-box-shadow: 0 0 3px  #AAAAAADD;
        box-shadow: 0 0 3px #AAAAAADD;
        /*box-shadow: 5px 5px 5px black;*/
        /*-webkit-box-shadow:1px 2px 4px #999999AA;*/
        /*-moz-box-shadow:1px 2px 4px #999999AA;*/
        /*box-shadow:1px 2px 4px #999999AA;*/
    }

    .im10 {
        width: 50%;
    }

    .tx_subcat, .tx_subcat_sel {
        cursor: pointer;
        font-size: 0.8em;
        /*color: var(--bg-blue);*/
        color: var(--blue-back-chegar);
        font-family: Humanst521LTBT;
        font-weight: bold;
    }
    .tx_subcat_sel {
        /*font-weight: bold;*/
        /*text-decoration: underline;*/
        font-family: Humanst521BT;
    }

    .im_id_container {
        display: flex;
        align-items: center;
        position: absolute;
        top: 0;
        right: 0;
        margin-right: 82px; /* Ajuste conforme necessário */
    }

    .im_id {
        width: 4vh;
        height: 4vh;
    }

    .tx_title_guia{
        margin-left: 50px;
    }

    @media screen and (min-width: 1100px) and (max-width: 1399px) {
        .im_id_container {
        display: flex;
        align-items: center;
        position: absolute;
        top: 0;
        margin-right: 82px; /* Ajuste conforme necessário */
        }

        .im40_2{
            margin-top: 4.5vh;
            margin-left: -0.5vh;
        }

        .im_id {
            width: 4vh;
            height: 4vh;
        }

        .tx_title_guia {
            font-size: 500%; /* Ajuste conforme necessário */
            margin-left: 10%;
        }
    
    }

    @media screen and (min-width: 1400px) and (max-width: 1549px) {
        .im_id_container {
        display: flex;
        align-items: center;
        position: absolute;
        top: 0;
        right: 0;
        margin-right: 82px; /* Ajuste conforme necessário */
        }

        .im40_2{
            margin-top: 4.5vh;
            margin-left: -0.5vh;
        }

        .tx_title_guia {
            font-size: 500%; /* Ajuste conforme necessário */
        }


        .tx_login2 {
            display: flex;
            justify-content: center;
            align-items: center;
            text-align: center;
            height: 40px;
            width: 110px;
            background-color: #9c27b0; /* Ajuste conforme necessário */
            color: #fff; /* Ajuste conforme necessário */
            border: none; /* Ajuste conforme necessário */
            border-radius: 5px; /* Ajuste conforme necessário */
            cursor: pointer;
            padding: 0; /* Adicione se necessário para remover qualquer padding interno */
        }

    }


    @media screen and (min-width: 1550px) and (max-width: 1599px) {
        .im_id_container {
        display: flex;
        align-items: center;
        position: absolute;
        top: 0;
        right: 0;
        margin-right: 82px; /* Ajuste conforme necessário */
        }

        .im40_2{
            margin-top: 4.5vh;
            margin-left: -0.5vh;
        }

        .tx_title_guia {
            font-size: 500%; /* Ajuste conforme necessário */
            margin-left: 8%;
        }




    }

    @media screen and (min-width: 1600px) and (max-width: 1900px) {
        .im_id_container {
        display: flex;
        align-items: center;
        position: absolute;
        top: 0;
        right: 0;
        margin-right: 82px; /* Ajuste conforme necessário */
        }

        .im40_2{
            margin-top: 4.5vh;
            margin-left: -0.8vh;
        }

        .im_id {
            width: 4vh;
            height: 4vh;
        }

        .tx_title_guia {
            font-size: 500%; /* Ajuste conforme necessário */
            margin-left: 10%;
        }
    
    }

    @media screen and (min-width: 1901px) {
        .im_id_container {
        display: flex;
        align-items: center;
        position: absolute;
        top: 0;
        right: 0;
        margin-right: 82px; /* Ajuste conforme necessário */
        }

        .im40_2{
            margin-top: 4.5vh;
            margin-left: -0.6vh;
        }

        .im_id {
            width: 4vh;
            height: 4vh;
        }

        .tx_title_guia {
            font-size: 500%; /* Ajuste conforme necessário */
            margin-left: 15%;
        }
    
    }

    .tx_login2 {
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        height: 40px;
        width: 110px;
        background-color: #9c27b0; /* Ajuste conforme necessário */
        color: #fff; /* Ajuste conforme necessário */
        border: none; /* Ajuste conforme necessário */
        border-radius: 5px; /* Ajuste conforme necessário */
        cursor: pointer;
        padding: 0; /* Adicione se necessário para remover qualquer padding interno */
    }

    @media screen and (max-height: 900px) {
    .im_id_container {
        display: flex;
        align-items: center;
        position: absolute;
        top: 0;
        right: 0;
        margin-right: 76px; /* Ajuste conforme necessário */
    }

    .tx_login2 {
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        height: 35px;
        width: 110px;
        background-color: #9c27b0; /* Ajuste conforme necessário */
        color: #fff; /* Ajuste conforme necessário */
        border: none; /* Ajuste conforme necessário */
        border-radius: 5px; /* Ajuste conforme necessário */
        cursor: pointer;
        padding: 0; /* Adicione se necessário para remover qualquer padding interno */
    }

    .im40_2{
        margin-top: 6vh;
    }
    
    }

    @media screen and (min-height: 950px) {
    .tx_login2 {
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        height: 40px;
        width: 110px;
        background-color: #9c27b0; /* Ajuste conforme necessário */
        color: #fff; /* Ajuste conforme necessário */
        border: none; /* Ajuste conforme necessário */
        border-radius: 5px; /* Ajuste conforme necessário */
        cursor: pointer;
        padding: 0; /* Adicione se necessário para remover qualquer padding interno */
    }

}
</style>


// WEBPACK FOOTER //
// src/components/Home.vue